<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.workers'), $t('text.list')]">
        <el-button
          v-if="Permit.canActionsChargeEdition('mesWorkerManage')"
          type="success"
          size="mini"
          @click="add"
          >+ {{ $t("text.create") }}</el-button
        >
        <el-button type="default" size="mini" @click="addImport">{{
          $t("action.import")
        }}</el-button>
      </breadcrumb>
    </div>

    <div class="red font16 center pd10" style="padding: 10px">
      您的账户可新增{{ workerQuantity }}个工人，现已加入{{
        usedWorkerQuantity
      }}个
    </div>

    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.keyword"
            :placeholder="$t('placeholder.workersNameSerialNo')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-dropdown
              v-if="Permit.canActionsChargeEdition('mesWorkerManage')"
              menu-align="start"
              trigger="click"
              class="mgr10"
            >
              <el-button type="warning" size="mini">
                设置产线
                <i class="el-icon-caret-bottom el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="factory of factories"
                  :key="factory.id"
                >
                  <div @click="selectFactory(factory)">{{ factory.name }}</div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button
              type="default"
              size="mini"
              @click="printQrCodes('printQrCodesDiv')"
              >{{ $t("action.printWorker") }}</el-button
            >
            <el-dropdown class="mgl10" @command="download">
              <el-button type="default" size="mini">
                {{ $t("action.download") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="checked">
                  {{ $t("action.downLoadChecked") }}</el-dropdown-item
                >
                <el-dropdown-item command="search">
                  {{ $t("action.downLoadSearch") }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        :checkbox-config="{ reserve: true }"
        @sort-change="sortRecords"
        :loading="loading"
        id="workerTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="checkbox"
          type="checkbox"
          width="35"
        ></vxe-table-column>
        <vxe-table-column width="60px">
          <template v-slot="{ row, rowIndex }">
            <i
              v-if="rowIndex != 0"
              class="el-icon-top mgr10"
              @click="swapSequence(row, rowIndex, 'up')"
            ></i>
            <i
              v-if="
                rowIndex + 1 !=
                (pager.pageSize > pager.total ? pager.total : pager.pageSize)
              "
              class="el-icon-bottom"
              @click="swapSequence(row, rowIndex, 'down')"
            ></i>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="name"
          :title="$t('worker.name')"
          min-width="80"
        />
        <vxe-table-column
          field="serialNo"
          :title="$t('worker.serialNo')"
          min-width="100"
          sortable
        />
        <vxe-table-column
          field="phone"
          :title="$t('worker.phone')"
          min-width="100"
        />

        <vxe-table-column
          field="workerPhases"
          :title="$t('worker.phases')"
          min-width="200"
        >
          <template v-slot="{ row }">
            <span
              v-if="row.workerPhases != null && row.workerPhases.length != 0"
              >{{ row.workerPhases.map((p) => p.phaseName).join("，") }}</span
            >
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="workerFactories"
          :title="$t('worker.factories')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <span
              v-if="
                row.workerFactories != null && row.workerFactories.length != 0
              "
              >{{
                row.workerFactories
                  .map((p) => p.factory && p.factory.name)
                  .join("，")
              }}</span
            >
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="voidAt"
          :title="$t('user.voidInfo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <span v-if="row.voidAt !== null" class="red">{{
              $t("authorizes.void")
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="token"
          :title="$t('worker.token')"
          min-width="100"
        />
        <vxe-table-column
          field="entryAt"
          :title="$t('worker.entryAt')"
          min-width="110"
        />
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="60"
        />
        <vxe-table-column
          v-if="Permit.canActionsChargeEdition('mesWorkerManage')"
          :title="$t('text.action')"
          width="150"
        >
          <template v-slot="{ row }">
            <el-button
              v-if="row.voidAt == null"
              type="text"
              size="mini"
              @click="edit(row)"
              >{{ $t("text.edit") }}</el-button
            >
            <el-button
              v-if="row.voidAt == null"
              type="text"
              size="mini"
              @click="setInvalid(row)"
              >{{ $t("action.setInvalid") }}</el-button
            >
            <el-button
              v-if="row.voidAt !== null"
              type="text"
              size="mini"
              @click="recoveryRow(row)"
              >{{ $t("action.recovery") }}</el-button
            >
            <el-button
              v-if="row.voidAt !== null"
              type="text"
              size="mini"
              @click="deleteRow(row)"
              >{{ $t("text.delete") }}</el-button
            >
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <!-- 新增 -->
    <el-dialog
      :title="$t('text.create')"
      :close-on-click-modal="false"
      :visible.sync="addDF"
      width="50%"
    >
      <el-form ref="addObjForm" :model="addObj" label-width="80px">
        <fieldset class="mgb15">
          <legend>{{ $t("text.baseInfo") }}</legend>
          <el-row>
            <el-col :span="8">
              <el-form-item
                :label="$t('worker.name')"
                :prop="'name'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('worker.name')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input size="small" v-model.trim="addObj.name" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$t('worker.serialNo')"
                :prop="'serialNo'"
                :rules="[
                  {
                    required: true,
                    validator: validateSerialNo,
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  size="small"
                  v-model.trim="addObj.serialNo"
                  :placeholder="$t('prompt.alphabetNumber')"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('worker.phone')" :prop="'phone'">
                <el-input size="small" v-model.trim="addObj.phone" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="$t('worker.entryAt')" :prop="'entryAt'">
                <el-date-picker
                  size="small"
                  v-model="addObj.entryAt"
                  type="date"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item :label="$t('text.remark')" :prop="'remark'">
                <el-input size="small" v-model.trim="addObj.remark" />
              </el-form-item>
            </el-col>
          </el-row>
        </fieldset>
        <fieldset class="mgb15">
          <legend>
            {{ $t("worker.phases") }}
            <el-checkbox
              class="mgl10"
              v-model="checkAllPhases"
              :indeterminate="isIndeterminatePhases"
              @change="handleCheckAllPhasesChange"
              >{{ $t("action.checkAll") }}</el-checkbox
            >
          </legend>
          <el-checkbox-group
            size="small"
            v-model="checkedPhases"
            @change="handleCheckedPhasesChange"
          >
            <el-checkbox
              style="width: 100px"
              v-for="phase of phases"
              :key="phase.id"
              :label="phase"
              >{{ Util.limitText(phase.name, 6) }}</el-checkbox
            >
          </el-checkbox-group>
        </fieldset>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addDoing"
          size="small"
          @click="addSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editDF"
      width="50%"
    >
      <el-form ref="editObjForm" :model="editObj" label-width="80px">
        <fieldset class="mgb15">
          <legend>{{ $t("text.baseInfo") }}</legend>
          <el-row>
            <el-col :span="8">
              <el-form-item
                :label="$t('worker.name')"
                :prop="'name'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('worker.name')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input size="small" v-model.trim="editObj.name" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$t('worker.serialNo')"
                :prop="'serialNo'"
                :rules="[
                  {
                    required: true,
                    validator: validateSerialNoEdit,
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  size="small"
                  v-model.trim="editObj.serialNo"
                  :placeholder="$t('prompt.alphabetNumber')"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('worker.phone')" :prop="'phone'">
                <el-input size="small" v-model.trim="editObj.phone" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="$t('worker.entryAt')" :prop="'entryAt'">
                <el-date-picker
                  size="small"
                  v-model="editObj.entryAt"
                  type="date"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item :label="$t('text.remark')" :prop="'remark'">
                <el-input size="small" v-model.trim="editObj.remark" />
              </el-form-item>
            </el-col>
          </el-row>
        </fieldset>
        <fieldset class="mgb15">
          <legend>
            {{ $t("worker.phases") }}
            <el-checkbox
              class="mgl10"
              v-model="checkAllPhasesEdit"
              :indeterminate="isIndeterminatePhasesEdit"
              @change="handleCheckAllPhasesChangeEdit"
              >{{ $t("action.checkAll") }}</el-checkbox
            >
          </legend>
          <el-checkbox-group
            size="small"
            v-model="checkedPhaseIdsEdit"
            @change="handleCheckedPhasesChangeEdit"
          >
            <el-checkbox
              style="width: 100px"
              v-for="phase of phases"
              :key="phase.id"
              :label="phase.id"
              >{{ Util.limitText(phase.name, 6) }}</el-checkbox
            >
          </el-checkbox-group>
        </fieldset>
        <fieldset class="mgb15">
          <legend>{{ $t("worker.factories") }}</legend>
          <el-checkbox-group size="small" v-model="checkedFactoryIdsEdit">
            <el-checkbox
              style="width: 100px"
              v-for="factory of factories"
              :key="factory.id"
              :label="factory.id"
              >{{ Util.limitText(factory.name, 6) }}</el-checkbox
            >
          </el-checkbox-group>
        </fieldset>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editDoing"
          size="small"
          @click="editSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <div id="printQrCodesDiv" style="display: none">
      <div
        v-for="(item, index) in selectRecords"
        :key="index"
        :style="
          'margin:0 auto 10px; width:200px; text-align:left; font-size: 14px;' +
          (index == 0 ? '' : 'page-break-before: always;')
        "
      >
        <div>
          <qrcode
            :value="item.serialNo"
            :options="{ width: 100 }"
            :tag="'img'"
          />
        </div>
        <div style="margin-left: 10px">
          {{ $t("worker.serialNo") }}：{{ item.serialNo }}
        </div>
        <div style="margin-left: 10px">
          {{ $t("worker.name") }}：{{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Qrcode from "@chenfengyuan/vue-qrcode";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Worker from "@/api/worker.js";
import Phase from "@/api/phase.js";
import Tenant from "@/api/tenant.js";
import Factory from "@/api/factory.js";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: { Qrcode },
  data() {
    var validateSerialNo = (rule, value, callback) => {
      const self = this;
      if (value == null || value.trim() === "") {
        callback(
          new Error(self.$t("rules.required", [self.$t("worker.serialNo")]))
        );
        return;
      }
      if (!Util.regexAlphabetNumber(value)) {
        callback(
          new Error(self.$t("rules.regex", [self.$t("worker.serialNo")]))
        );
      }

      Worker.findBySerialNo({ serialNo: value }).then(function (res) {
        if (res.data.code === 200) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("worker.serialNo")]))
          );
          return;
        } else {
          callback();
        }
      });
    };
    var validateSerialNoEdit = (rule, value, callback) => {
      const self = this;
      if (value == null || value.trim() === "") {
        callback(
          new Error(self.$t("rules.required", [self.$t("worker.serialNo")]))
        );
        return;
      }
      if (!Util.regexAlphabetNumber(value)) {
        callback(
          new Error(self.$t("rules.regex", [self.$t("worker.serialNo")]))
        );
      }
      Worker.findBySerialNo({ serialNo: value.trim() }).then(function (res) {
        if (res.data.code === 200 && res.data.entity.id !== self.row.id) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("worker.serialNo")]))
          );
          return;
        } else {
          callback();
        }
      });
    };
    return {
      narrows: [
        [
          {
            label: this.$t("user.voidInfo"),
            items: [
              {
                label: this.$t("authorizes.noVoid"),
                key: "invalidNo",
                condition: { invalid: "no" },
              },
              {
                label: this.$t("authorizes.void"),
                key: "invalidYes",
                condition: { invalid: "yes" },
              },
            ],
          },
        ],
      ],
      initFilter: "invalidNo",
      searchForm: {
        productNo: null,
      },
      sorter: {
        sortBy: "workers_sequence",
        sortIndicator: "desc",
      },
      sorterMap: {
        serialNo: "workers_serialNo",
      },
      Util: Util,
      //
      workerQuantity: null,
      usedWorkerQuantity: null,
      phases: [],
      factories: [],
      // 新增
      validateSerialNo: validateSerialNo,
      addDF: false,
      addObj: {
        name: null,
        serialNo: null,
        workerPhases: [],
        workerFactories: [],
        phone: null,
        entryAt: new Date(),
        remark: null,
      },
      checkedPhases: [],
      isIndeterminatePhases: false,
      checkAllPhases: false,
      addDoing: false,
      // 编辑
      validateSerialNoEdit: validateSerialNoEdit,
      editDF: false,
      row: null,
      editObj: {
        name: null,
        serialNo: null,
        workerPhases: [],
        phone: null,
        entryAt: new Date(),
        remark: null,
      },
      checkedPhaseIdsEdit: [],
      isIndeterminatePhasesEdit: false,
      checkAllPhasesEdit: false,

      checkedFactoryIdsEdit: [],
      editDoing: false,
    };
  },
  created() {
    const self = this;
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });
    self.loadingStart();
    axios.all([Phase.findByTenantId(), Factory.findByTenantId()]).then(
      axios.spread(function (phases, factories) {
        if (phases.status === 200) {
          self.phases = phases.data;
        } else {
          self.sysError();
        }
        if (factories.status === 200) {
          self.factories = factories.data;
        } else {
          self.sysError();
        }
        self.getTenant();
        self.loadingEnd();
      })
    );
  },
  methods: {
    //
    selectFactory(factory) {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      let obj = {
        workerIds: self.selectRecords.map((s) => s.id),
        factoryId: factory.id,
      };
      Worker.batchSetFacotry(obj).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.setSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },

    swapSequence(row, rowIndex, type) {
      const self = this;
      const obj = {
        swapId: row.id,
        swapId2:
          type == "up"
            ? self.records[rowIndex - 1].id
            : self.records[rowIndex + 1].id,
      };
      Worker.swapSequence(obj).then(function (res) {
        if (res.status == 200) {
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    // 下载
    download(type) {
      const self = this;
      if (type === "checked") {
        if (!self.downloadChecked(self.selectRecords)) {
          return;
        }
        const data = {
          currentPage: 1,
          pageSize: self.limitNumber(),
          ids: this.selectRecords.map((c) => c.id),
        };
        this.downloadData(data);
      } else {
        if ((JSON.stringify(self.conditions) === "{}") === true) {
          this.$message.error(this.$t("prompt.downloadNoSearchCondition"));
          return;
        }
        if (!self.downloadSearch(self.pager.total)) {
          return;
        }
        const data = JSON.parse(JSON.stringify(self.combineParams()));
        data.pageSize = self.limitNumber();
        self.downloadData(data);
      }
    },
    downloadData(data) {
      const self = this;
      Worker.exportExcel(data).then(function (res) {
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.loadData();
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },
    // 打印二维码
    printQrCodes(type) {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      self.printFunction(type);
      self.loadData();
    },
    // 设置失效
    setInvalid(row) {
      const self = this;
      if (confirm(this.$t("prompt.setInvalid"))) {
        Worker.invalid(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.setSuccess"),
              type: "success",
            });
            self.loadData();
            self.getTenant();
          } else {
            self.sysError();
          }
        });
      }
    },
    // 删除
    deleteRow(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        Worker.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.sysResult(res.data);
            self.loadData();
            self.getTenant();
          } else {
            self.sysError();
          }
        });
      }
    },
    recoveryRow(row) {
      const self = this;
      Worker.recover(row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.setSuccess"),
            type: "success",
          });
          self.loadData();
          self.getTenant();
        } else {
          self.sysError();
        }
      });
    },

    // 编辑
    edit(row) {
      const self = this;
      self.row = row;
      self.editObj.name = row.name;
      self.editObj.serialNo = row.serialNo;
      self.editObj.phone = row.phone;
      self.editObj.entryAt = row.entryAt;
      self.editObj.remark = row.remark;
      self.checkedPhaseIdsEdit = row.workerPhases.map((w) => w.phaseId);
      self.checkedFactoryIdsEdit = row.workerFactories.map(
        (w) => w.factory && w.factory.id
      );
      self.editDoing = false;
      self.editDF = true;
    },
    //
    handleCheckAllPhasesChangeEdit(val) {
      this.checkedPhaseIdsEdit = val ? this.phases.map((c) => c.id) : [];
    },
    handleCheckedPhasesChangeEdit(value) {
      const checkedCount = value.length;
      this.checkAllPhasesEdit = checkedCount === this.phases.length;
      this.isIndeterminatePhasesEdit =
        checkedCount > 0 && checkedCount < this.phases.length;
    },
    editSubmit() {
      const self = this;
      self.$refs.editObjForm.validate((valid) => {
        if (valid) {
          if (self.checkedPhaseIdsEdit.length === 0) {
            self.$message({
              message: self.$t("prompt.atLeastSelectOnePhase"),
              type: "warning",
            });
            return;
          }
          self.editObj.workerPhases = [];
          for (const c of self.checkedPhaseIdsEdit) {
            const existPhase = self.phases.find((p) => p.id === c);
            if (existPhase != null) {
              self.editObj.workerPhases.push({
                phaseId: c,
                phaseName: existPhase.name,
              });
            }
          }
          self.editObj.workerFactories = [];
          for (const c of self.checkedFactoryIdsEdit) {
            const existFactory = self.factories.find((p) => p.id === c);
            if (existFactory != null) {
              self.editObj.workerFactories.push({
                factoryId: c,
              });
            }
          }
          self.editObj.entryAt = Util.formatDate(self.editObj.entryAt);
          self.editDoing = true;
          Worker.update(self.row.id, self.editObj).then(function (res) {
            self.editDoing = false;
            self.editDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    addImport() {
      const self = this;
      if (this.usedWorkerQuantity >= this.workerQuantity) {
        self.$message({
          message: self.$t("prompt.workerQtyBeyond"),
          type: "warning",
        });
        return;
      }
      self.$router.push({ name: "mesWorkersNewImport" });
    },
    // 新增
    add() {
      const self = this;
      if (this.usedWorkerQuantity >= this.workerQuantity) {
        self.$message({
          message: self.$t("prompt.workerQtyBeyond"),
          type: "warning",
        });
        return;
      }
      self.addObj.name = null;
      self.addObj.serialNo = null;
      self.addObj.workerPhases = [];
      self.checkedPhases = [];
      self.addObj.phone = null;
      self.addObj.entryAt = Util.formatDate(new Date());
      self.addObj.remark = null;
      self.addDoing = false;
      self.addDF = true;
    },
    handleCheckAllPhasesChange(val) {
      this.checkedPhases = val ? this.phases : [];
    },
    handleCheckedPhasesChange(value) {
      const checkedCount = value.length;
      this.checkAllPhases = checkedCount === this.phases.length;
      this.isIndeterminatePhases =
        checkedCount > 0 && checkedCount < this.phases.length;
    },
    addSubmit() {
      const self = this;
      this.$refs.addObjForm.validate((valid) => {
        if (valid) {
          if (self.checkedPhases.length === 0) {
            self.$message({
              message: self.$t("prompt.atLeastSelectOnePhase"),
              type: "warning",
            });
            return;
          }
          self.addObj.workerPhases = self.checkedPhases.map((c) => {
            return { phaseId: c.id, phaseName: c.name };
          });
          self.addObj.entryAt = Util.formatDate(self.addObj.entryAt);
          self.addDoing = true;
          Worker.create(self.addObj).then(function (res) {
            self.addDoing = false;
            self.addDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.loadData();
              self.getTenant();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    //
    getTenant() {
      const self = this;
      Tenant.findById(self.Permit.currentTenant().id).then(function (res) {
        if (res.data.code === 200) {
          const tenant = res.data.entity;
          self.workerQuantity =
            tenant.charge.workerQuantity + tenant.charge.addedWorkerQuantity;
          self.usedWorkerQuantity = tenant.charge.usedWorkerQuantity;
        } else {
          self.sysError();
        }
      });
    },
    //
    dataProvider(params) {
      return Worker.search(params);
    },
  },
};
</script>
<style scoped>
</style>